export const FETCH_PACKAGES_REQUEST = "FETCH_PACKAGES_REQUEST";
export const CREATE_PACKAGES_REQUEST = "CREATE_PACKAGES_REQUEST";
export const UPDATE_PACKAGES_WEIGHT_REQUEST = "UPDATE_PACKAGES_WEIGHT_REQUEST";
export const UPDATE_PACKAGES_STATUS_REQUEST = "UPDATE_PACKAGES_STATUS_REQUEST";
